import * as React from 'react';
import { Modal } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import icon2 from '../../../img/icon2.png';

interface IProps
{
    show: boolean;
    onClick: () => void;
}

export const CouponRegisterModal = (props: IProps) =>
    <Modal show={props.show}>
        <Modal.Body style={{ padding: "3rem" }}>
            <div className="text-center">
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <a className="header__logo-1">
                        <img src={icon2} alt="" />
                    </a>
                </div>
                <br />
                <div className="h3">
                    Cupom validado com sucesso!
                </div>
                <div className="h4">
                    <NavLink to="/store-search">
                        busque a fármacia 
                    </NavLink> participante
                </div>
                <div className="h3">
                    mais próxima a você e boas compras :)
                </div>
                <button className="btn-primary" onClick={props.onClick}>
                    OK
                </button>
            </div>
        </Modal.Body>
    </Modal>

export default CouponRegisterModal;